<template>
  <div class="bg-light">
    <v-card elevation="0">
      <UmkmBermitraMainCarousel></UmkmBermitraMainCarousel>

      <v-card-actions class="bg-light">
        <div class="ml-8">
          <div class="headline font-weight-bold blue--text text--darken-2">
            UMKM SIAP BERMITRA
          </div>
          <div class="mt-n2 subtitle-2 font-weight-regular grey--text text--darken-2">
            UMKM berkomitmennya untuk bermitra dengan pihak lain
          </div>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex align-center">
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              v-if="searchShow"
              class="mr-4"
              dense
              @blur.stop="searchBlur"
              @keyup.enter="searchOnEnter"></v-text-field>
          <v-btn icon class="mr-1 font-weight-bold"  color="blue" @click="searchShow=true" v-if="! searchShow"><v-icon>mdi-magnify</v-icon></v-btn>
          <v-btn class="mr-1 rounded-lg" dark color="blue" x-small @click="umkmTypeClick({id:0})">All</v-btn>
          <div v-for="(item, i) in itemsFUmkmType" :key="i">
            <v-btn outlined class="mr-1 rounded-lg blue--text" x-small @click="umkmTypeClick(item)">{{item.description}}</v-btn>
          </div>
        </div>
      </v-card-actions>
    </v-card>

    <v-card class="elevation-0 service bg-light text-center">
      <v-card-text>
        <v-row class="py-4 justify-center" v-if="fUmkmFiltered.length < 1">
          <v-col cols="12" align="center">
            <span>{{lang === "id" ? "Data Tidak Tersedia" : "No Data Available"}}</span>
          </v-col>
        </v-row>

        <v-layout wrap class="d-flex mt-2 justify-center">
          <div v-for="(item, i) in fUmkmFiltered" :key="i">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card
                    min-height="320"
                    max-width="250"
                    xs12
                    sm4
                    px-3
                    class="ma-3 rounded-lg"
                    :elevation="hover ? 16 : 3"
                >
                  <div>
                    <v-hover>
                      <template v-slot:default="{ hover }">
                        <router-link
                            style="text-decoration: none"
                            to="#"
                        >
                          <v-img
                              height="150"
                              :lazy-src="lookupImageUrlLazy(item)"
                              :src="lookupImageUrl(item)"
                              :class="{ 'hover-image': hover }"
                              class="rounded-lg"
                          >
                            <v-card-title class="top-edge mt-n3 mr-n3">
                              <v-spacer></v-spacer>
                              <v-btn
                                  small
                                  color="rgb(204, 96, 223, 0.5)"
                                  class="font-weight-black"
                              ><v-icon color="orange"></v-icon> {{ lookupFUmkmType(item.fumkmTypeBean).description }}</v-btn>

                            </v-card-title>
                          </v-img>
                        </router-link>
                      </template>
                    </v-hover>
                  </div>

                  <v-card-text class="mt-n3">
                    <div class="text-left subtitle-1 black--text text--darken-2"  v-if="lang === 'id'">
                      {{ item.description }}
                    </div>

                    <div class="d-flex" v-if="item.itemsPermit.lenght > 0">
                      <v-icon x-small class="mr-1" color="green">mdi-check-circle-outline</v-icon>
                      <span class="caption blue--text">{{ item.itemsPermit }}</span>
                    </div>
                    <div class="d-flex" v-if="item.fsubAreaBean >0">
                      <v-icon x-small class="mr-1" color="blue">mdi-map-marker</v-icon>
                      <span class="caption font-weight-light">{{ lookupFSubArea(item.fsubAreaBean).description }}, {{ lookupFArea(lookupFSubArea(item.fsubAreaBean).fareaBean).description }}</span>
                    </div>
                    <div class="d-flex align-baseline">
                      <v-icon x-small>mdi-calendar-range</v-icon>
                      <span class="caption ml-1">{{ formatDate(item.tanggalBerdiri, "dd MMM yyyy") }}</span>
                    </div>

                    <div class="d-flex mt-1 caption text-left low-line-height">
                      {{ shrinkTeks(item.notes) }}
                    </div>

                    <div
                        class="text-left caption mt-2 mb-1 caption low-line-height"
                    >
                      <span class="mr-1 font-weight-regular font-italic"
                      >needs:</span
                      >
                      <span class="black--text">{{ item.needs?
                          shrinkTeks(item.needs) : "-"
                        }}</span>
                    </div>
                    <div class="caption green--text" v-if="item.itemsPermit.length >0">
                      {{ item.itemsPermit.map((x) => lookupFPermit(x.fpermitBean).description).join(", ") }}
                    </div>

                    <v-flex class="d-flex child-flex mb-1">
                      <div class="d-flex align-baseline orange--text">
                        <span><v-icon small>mdi-cash</v-icon></span>
                        <span class="ml-1 caption">omset</span>
                        <span class="ml-1 caption">{{formatNumberString(item.omset)}}</span>
                      </div>
                    </v-flex>

                    <v-flex class="d-flex block mt-1">
                      <v-btn
                          outlined
                          class="rounded-lg mx-1"
                          dark
                          color="blue"
                          x-small
                          width="100%"
                          @click="toUmkmDetil(item)"
                      >
                        Detail
                      </v-btn>

                      <v-btn
                          v-if="false"
                          icon
                          class="rounded-lg"
                          color="pink"
                          x-small
                      >
                        <v-icon>mdi-heart-outline</v-icon>
                      </v-btn>

                    </v-flex>

                  </v-card-text>
                </v-card>
              </template>
            </v-hover>
          </div>
        </v-layout>

        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="10" md="9" sm="8" align="right">
              <v-pagination
                  v-model="currentPage"
                  :length="totalPaginationPages"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-card class="mx-2 mb-1 rounded-lg">
      <UmkmBermitraMainMap
          :itemsFDayaDukung="itemsFDayaDukung"
          :itemsFDayaDukungType="itemsFDayaDukungType"
          :itemsFSectorType="itemsFSectorType"
          :itemsFUmkmType="itemsFUmkmType"
          :itemsFArea="itemsFArea"
          :itemsFSubArea="itemsFSubArea"
          :itemsFUmkm="fUmkmFiltered"
          :itemsFInfrastructureType="itemsFInfrastructureType"
          :itemsFKomoditiType="itemsFKomoditiType"
      ></UmkmBermitraMainMap>
    </v-card>

  </div>
</template>

<script>
import UmkmBermitraMainMap from "@/components/public-umkm-bermitra/UmkmBermitraMainMap.vue";
import FUmkmFilter from "@/models/payload/f-potensi-filter";
import FUmkmService from "@/services/apiservices-umkm/f-umkm-service";
import FileService from "@/services/apiservices-umkm/file-service";
import { format, parseISO } from "date-fns";
import FSubAreaService from "@/services/apiservices/f-sub-area-service";
import FAreaService from "@/services/apiservices/f-area-service";
import FUmkmTypeService from "@/services/apiservices-umkm/f-umkm-type-service";
import UmkmBermitraMainCarousel from "@/components/public-umkm-bermitra/UmkmBermitraMainCarousel.vue";
import FPermitService from "@/services/apiservices-umkm/f-permit-service";
import FSectorTypeService from "@/services/apiservices/f-sector-type-service";
import FInfrastructureTypeService from "@/services/apiservices/f-infrastructure-type-service";
import FKomoditiTypeService from "@/services/apiservices/f-komoditi-type-service";
import FDayadukungService from "@/services/apiservices/f-dayadukung-service";

export default {
  name: "UmkmBermitraMain",
  props: {
  },
  components: {
    UmkmBermitraMainCarousel,
    UmkmBermitraMainMap,
  },
  data() {
    return {
      showInfo: true,
      searchShow: false,
      infoDialogMessage: "",

      currentPage: 1,
      totalTablePages: 1,
      totalPaginationPages: 1,
      pageSize: 9,
      pageSizes: [9, 25, 50, 150, 500],

      search: "",
      filterFareaList: [],
      filterFumkmTypeList: [],
      headers: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "coverImage",
          width: "20%",
        },
        { text: "", value: "title", width: "30%" },
      ],

      formMode: "",
      itemSelectedIndex: -1,
      itemSelected: "",
      itemsFDivision: [],

      jenis: String,
      itemsFUmkm: [],
      itemsFArea: [],
      itemsFSubArea: [],
      itemsFDayaDukung: [],
      itemsFDayaDukungType: [],
      itemsFInfrastructureType: [],
      itemsFKomoditiType: [],
      itemsFUmkmType: [],
      itemsFPermit: [],
      itemsFSectorType: [],

      itemsFUmkmMarker: [],
    };
  },
  computed: {
    itemsFUmkmMarkerX: {
      get() {
        return this.$store.state.umkm.itemsFUmkmMarker;
      },
      set(value) {
        this.$store.dispatch("umkm/updateItemsFUmkmMarker", value);
      },
    },

    lang: {
      get() {
        return this.$store.state.langModule.lang;
      },
      set(val) {
        this.$store.dispatch("langModule/setLang", val);
      },
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    fUmkmFiltered() {
      let umkmesModified = [];
      const listUmkm = this.$store.state.umkm.itemsFUmkm.filter(item => item.statusActive===true);
      for (let i = 0; i < listUmkm.length; i++) {
        let itemBerita = listUmkm[i];
        if (itemBerita.contentBody !== undefined) {
          if (itemBerita.contentBody.length > 100) {
            itemBerita.contentBody = itemBerita.contentBody.substr(0, 99);
          }
        }
        umkmesModified.push(itemBerita);
      }


      return umkmesModified;
    },
    computedItemsFSubArea(){
      return this.$store.state.umkm.itemsFSubArea
    },
  },
  watch: {
    lang: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          // this.fetchFUmkmType()
        }
      },
    },
    currentPage: {
      handler: function (value) {
        if (value) this.fetchFUmkm();
      },
    },
    pageSize: {
      handler: function (value) {
        const refreshData = this.currentPage === 1;
        this.currentPage = 1;
        if (refreshData) {
          console.log("Change PageSize " + value);
          this.fetchFUmkm();
        }
      },
    },
  },
  methods: {
    fetchFInfrastructureTypeForMap() {
      FInfrastructureTypeService.getAllFInfrastructureTypePublic()
          .then((response) => {
            this.itemsFInfrastructureType = response.data;
          })
          .catch((e) => {
            console.log(e);
          });
    },
    fetchFKomoditiTypeForMap() {
      FKomoditiTypeService.getAllFKomoditiTypePublic()
          .then((response) => {
            this.itemsFKomoditiType = response.data;
          })
          .catch((e) => {
            console.log(e);
          });
    },

    fetchFDayaDukungForMap() {
      FDayadukungService.getAllFDayaDukungWithParentPublic()
          .then((response) => {
            const { items, fDayaDukungTypes } = response.data;
            try {
              this.itemsFDayaDukung = items.map((item) => {
                item.fdayaDukungType = fDayaDukungTypes.find(
                    (fDayaDukungType) =>
                        fDayaDukungType.id === item.fdayaDukungTypeBean
                );
                // Validasi setiap property item untuk memastikan tidak ada NaN atau undefined
                Object.keys(item).forEach((key) => {
                  if (typeof item[key] === "number" && isNaN(item[key])) {
                    item[key] = null; // Ganti NaN dengan null atau nilai default lain jika diinginkan
                  }
                });

                return item;
              });
              this.itemsFDayaDukungType = fDayaDukungTypes;

            }catch (e) {
              e.toString()
            }

          })
          .catch((e) => {
            console.log(e);
          });
    },
    formatDate(date, pattern){
      return format(parseISO(date), pattern)
    },
    toUmkmDetil(item) {
      this.$router.push(
          "/public-umkm-siap-bermitra-detail/" +
          this.linkNeated(item.id.toString())
      );
    },
    searchOnEnter() {
      this.fetchFUmkm();
    },
    searchBlur() {
      this.searchShow = false;
      this.search = ""
    },
    umkmTypeClick(item) {

      if (item.id===0){
        this.filterFumkmTypeList = [];
      }else {
        this.filterFumkmTypeList = [item.id];
      }
      this.fetchFUmkm()
    },

    fetchParent(){
      FSectorTypeService.getAllFSectorTypePublic().then(
          response => {
            this.itemsFSectorType = response.data
            // console.log(JSON.stringify(response.data))
          }
      )
      FSubAreaService.getAllFSubAreaPublic().then(
          response => {
            // this.$store.dispatch("umkm/updateItemsFSubArea", response.data)
            this.itemsFSubArea = response.data
          }
      )
      FAreaService.getAllFAreaPublic().then(
          response => {
            // this.$store.dispatch("umkm/updateItemsFArea", response.data)
            this.itemsFArea = response.data

          }
      )

      FUmkmTypeService.getAllFUmkmTypePublic().then(
          response => {
            this.itemsFUmkmType = response.data
          },
          error =>{
            console.log(error)
          }
      )
      FPermitService.getAllFPermitPublic().then(
          (response) => {
            this.itemsFPermit = response.data;
            // console.log(JSON.stringify(response.data));
          },
          (error) => {
            console.log(error.response);
          }
      );

      FUmkmService.getAllFUmkmPublic().then(
          (response) => {
            // this.$store.dispatch("umkm/updateItemsFUmkm", response.data);
            this.itemsFUmkmMarker = response.data;
            // console.log(JSON.stringify(response.data));
          },
          (error) => {
            console.log(error.response);
          }
      );

    },
    fetchFUmkm() {
      return new Promise((resolve, reject) => {
        this.$store.dispatch("umkm/updateItemsFUmkm", []);

        const fumkmFilter = new FUmkmFilter();

        fumkmFilter.pageNo = this.currentPage;
        fumkmFilter.pageSize = this.pageSize;
        fumkmFilter.search = this.search;

        fumkmFilter.fareaIds = this.filterFareaList;
        fumkmFilter.fumkmTypeIds = this.filterFumkmTypeList;

        // fumkmFilter.jenis = this.filterFumkmTypeBean;
        // fumkmFilter.fareaIds = this.filterFareaBean;
        // if (fumkmFilter.fareaIds.length === 0) fumkmFilter.fareaIds = [];

        FUmkmService.getAllFUmkmContainingExtPublic(
            fumkmFilter
        ).then(
            (response) => {
              const { items, totalPages } = response.data;
              this.$store.dispatch(
                  "umkm/updateItemsFUmkm",
                  items.filter((x) => x.statusActive)
              );

              this.totalPaginationPages = totalPages;
              resolve(); // Resolve the promise here
            },
            (error) => {
              console.log(error.response);
              reject(error); // Reject the promise in case of error
            }
        );
      });
    },

    linkNeated(link) {
      return link.replace(/\s+/g, "-").toLocaleLowerCase();
    },
    shrinkTeks(str) {
      let newStr = str;
      if (str !== undefined) {
        if (str.length > 100) {
          newStr = str.substr(0, 99) + "...";
        }
      }
      return newStr;
    },

    getColorStatusActive(trueFalse) {
      if (trueFalse === true) return "green";
      else if (trueFalse === false) return "gray";
      else return "gray";
    },

    lookupFDivision(fdivisionBean) {
      const str = this.itemsFDivision.filter((x) => x.id === fdivisionBean);
      if (str.length > 0) {
        return str[0].description;
      } else {
        return "-";
      }
    },
    lookupFUmkmType(fumkmTypeBean) {
      const str = this.itemsFUmkmType.filter((x) => x.id === fumkmTypeBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    lookupFKomoditiType(fkomoditiTypeBean) {
      const str = this.itemsFKomoditiType.filter(
          (x) => x.id === fkomoditiTypeBean
      );
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    lookupFSubArea (fsubAreaBean) {
      const items = this.itemsFSubArea.filter(x => x.id===fsubAreaBean)
      if (items.length>0){
        return items[0]
      }else {
        return ""
      }
    },
    lookupFArea(fareaBean) {
      const str = this.itemsFArea.filter((x) => x.id === fareaBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "";
      }
    },
    lookupFPermit(fpermitBean) {
      const str = this.itemsFPermit.filter((x) => x.id === fpermitBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "";
      }
    },
    lookupImageUrl(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_low(item.avatarImage);
      }
    },
    lookupImageUrlLazy(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_verylow(item.avatarImage);
      }
    },

    computedDateFormattedDatefns(value) {
      return value ? format(parseISO(value), "dd-MMM-yyyy") : "";
    },
    dateTimeFormat(value) {
      return value ? format(parseISO(value), "dd-MMM-yyyy hh:mm:ss") : "";
    },
    formattedCurrencyValue(prefix, value) {
      if (!value) {
        return "0";
      }
      // return "Rp." + parseFloat(value).toFixed(0).toLocaleString()
      return prefix + "" + parseFloat(value).toLocaleString();
    },
    formatNumberString(value) {
      let valueStr = "";
      if (value / 1000000000 > 1) {
        valueStr = `${parseFloat(value / 1000000000).toLocaleString()} Miliar`;
      } else if (value / 1000000 > 1) {
        valueStr = `${parseFloat(value / 1000000).toLocaleString()} Juta`;
      } else if (value / 1000 > 1) {
        valueStr = `${parseFloat(value / 1000).toLocaleString()} Ribu`;
      } else {
        valueStr = value.toString();
      }
      return valueStr;
    },
  },
  mounted() {
    this.fetchParent();
    this.fetchFUmkm();

    this.fetchFDayaDukungForMap();
    this.fetchFInfrastructureTypeForMap();
    this.fetchFKomoditiTypeForMap();
  },
};
</script>

<style scoped>
.low-line-height {
  line-height: 1.2; /* Atur nilai line-height sesuai keinginan Anda */
}

.bg-light {
  background-color: #ece3f3;
}

</style>